import i18n from "locales/i18n";

function formatNumber(number: number): string {
  const lang = i18n.language;
  return new Intl.NumberFormat(lang).format(number);
}

export default formatNumber;
